// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"cb77fff5","98":"48ce913c","159":"0801d9fe","378":"6ee2706f","466":"b12cbfd1","734":"94873364","775":"f55e0cdb","780":"26c5f850"}[chunkId] + ".chunk.js";
};